import { render, staticRenderFns } from "./SetAsDone.vue?vue&type=template&id=dae7728c&scoped=true&"
import script from "./SetAsDone.vue?vue&type=script&lang=js&"
export * from "./SetAsDone.vue?vue&type=script&lang=js&"
import style0 from "./SetAsDone.vue?vue&type=style&index=0&id=dae7728c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae7728c",
  null
  
)

export default component.exports